import { useState } from 'react';
const FONT_SIZE_STORAGE_KEY = 'strata:editor_font_size';
function useFontSize() {
    const [fontSize, setFontSize] = useState(() => {
        const storedValue = localStorage.getItem(FONT_SIZE_STORAGE_KEY);
        const initialState = storedValue ? JSON.parse(storedValue) : null;
        return initialState;
    });
    const updateFontSize = (size) => {
        setFontSize(size);
        localStorage.setItem(FONT_SIZE_STORAGE_KEY, JSON.stringify(size));
    };
    return { fontSize, setFontSize: updateFontSize };
}
export default useFontSize;
//# sourceMappingURL=useFontSize.js.map